import { client } from '@hotjar/api-base-client';
import { sortBy } from 'lodash-es';
import { getCurrentUserOwnedAccountId } from '@hotjar/user';
import { prettifyDate } from '~/subscription-management/utils/date.utils';
import { getOldInvoicesQuery } from './get-old-invoices';
import type { Invoice, LegacyAccountInvoicesModel } from './invoices-types';

const mapLegacyToNewInvoices = (invoices: LegacyAccountInvoicesModel = []): Invoice[] => {
  return invoices.map((invoice) => ({
    amountWithTax: invoice.totalCost,
    balance: 0, // TODO: we don't use this at the moment
    documentUrl: `/invoices/${invoice.id}.pdf?token=${invoice.token}`,
    invoiceNumber: invoice.id.toString(),
    createdAt: prettifyDate(invoice.createdEpochTime * 1000),
    status: invoice.status,
  }));
};

export async function getInvoices(accountId: number): Promise<Invoice[]> {
  return client({ url: `/api/checkout/customers/${accountId}/invoices` });
}

export async function getAllInvoices(): Promise<Invoice[]> {
  const accountId = await getCurrentUserOwnedAccountId();

  if (accountId !== undefined) {
    const [legacyInvoices, invoices] = await Promise.allSettled([
      getOldInvoicesQuery({ accountId }),
      getInvoices(accountId),
    ]);

    return [
      ...(invoices.status === 'fulfilled' ? invoices.value : []),
      ...(legacyInvoices.status === 'fulfilled'
        ? mapLegacyToNewInvoices(
            sortBy(legacyInvoices.value, (invoice) => -invoice.createdEpochTime),
          )
        : []),
    ];
  }

  return [];
}
